import React, {useEffect, useState} from "react";
import {Button, Input} from "antd";
import useFetch, {CachePolicies} from "use-http";
import UIForwardSkeleton from "./UIForwardSkeleton";
import styles from "./UIForwardMessages.module.scss";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {Service} from "./ChatConstants";
import {getUrlHttp} from "src/service/util.service";

const UIForwardMessages = React.memo((props: any) => {
  const { Search } = Input;
  const { t } = useTranslation();
  const userId: string = props.userId; //'userIdtest' ;
  const currentGroupId: string = props.groupId; //  'groupIdtest'
  const [groupsDetail, setGroupsDetail]: any = useState([]);
  const [friendsDetail, setFriendsDetail]: any = useState([]);
  const [groupsResult, setGroupsResult]: any = useState([]);
  const [friendsResult, setFriendsResult]: any = useState([]);
  const [countSelect, setCountSelect]: any = useState(0);
  const [isLoading, setLoading]: any = useState(true);
  const [isLoadingData, setLoadingData]: any = useState(false);
  const apiGetGroups: any = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + Service.CenterGetGroup + "?limit=-1",
    {
      method:"get",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiGetFriends: any = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + Service.CenterGetFriends + "?limit=-1",
    {
      method:"get",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apicheckTopic: any = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + Service.CenterCheckTopic,
    {
      method:"post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiSaveListMessage: any = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveListMessages,
    {
      method:"post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const handleClickSelect = async (groupId: string) => {
    //@ts-ignore
    if (document.getElementById("check_" + groupId).checked) {
      //@ts-ignore
      document.getElementById("check_" + groupId).checked = false;
      setCountSelect(countSelect - 1);
    } else {
      //@ts-ignore
      document.getElementById("check_" + groupId).checked = true;
      setCountSelect(countSelect + 1);
    }
  };

  const forwerdMessageToAnotherChat = async () => {
    setCountSelect(0);
    setLoadingData(true);
    const checkGroup: any = document.querySelectorAll(
      'input[name="selectGroup"]:checked'
    );
    const checkfriend: any = document.querySelectorAll(
      'input[name="selectfriend"]:checked'
    );
    var msgBody: Array<object> = [];
    const messageSend: any = await _.sortBy(props.dataChecked, ["messageTime","messageId"]?.reverse?.());
    if(checkfriend?.length > 0){
      for (let checkItem of checkfriend) {
        msgBody = [];
        const groupID: string = await checkTopic(checkItem.value);
        messageSend?.forEach((item: any) => { 
          msgBody.push({
            groupId: groupID,
            messageType: item?.messageType,
            messageText: item?.messageText || "",
            messageDetails: item?.messageDetails,
          });
        });
        await handleSave(msgBody);
      }
    } 
    if(checkGroup.length > 0) {
      for (let checkItem of checkGroup) {
        msgBody = [];
        messageSend?.forEach((item: any) => { 
          msgBody.push({
            groupId: checkItem.value,
            messageType: item?.messageType,
            messageText: item?.messageText || "",
            messageDetails: item?.messageDetails,
          });
        });
        await handleSave(msgBody);
      }
    }
    props.handleCloseSelect();
    props.setOpenForward({ isOpen: false });
    // navigator.popPage({});
  };

  const checkTopic = async (friendsId: any) => {
    let responseData: any;
    try {
      responseData = await apicheckTopic.post({
        members: [{ userID: friendsId }],
      });
    } catch (error) {
      console.warn("Error checkTopic : ", error);
    }
    let result = responseData;
    return result.id;
  };

  const getGroups = async () => {
    getFriends();
    let responseData: any;
    try {
      responseData = await apiGetGroups.get();
      setLoading(false);
      let groups: any = responseData.groups;
      setGroupsDetail(groups);
      setGroupsResult(groups);
    } catch (error) {
      console.warn("Error apiGetGroups : ", error);
    }
  };

  const getFriends = async () => {
    let responseData: any;
    try {
      responseData = await apiGetFriends.get();
      setLoading(false);
      let friends: any = responseData.data;
      setFriendsDetail(friends);
      setFriendsResult(friends);
    } catch (error) {
      console.warn("Error getFriends : ", error);
    }
  };

  const handleSave = async (msgBody: any) => {
    let responseData: any;
    try {
      responseData = await apiSaveListMessage.post(msgBody);
      console.log('Send message Success : ', responseData);
    } catch (error) {
      console.warn("Error handleSave sendMessage : ", error);
    }
  };

  const getFullName = (friend: any) => {
    return `${friend.firstname || ""} ${friend.lastname || ""}`
  }

  useEffect(() => {
    // when mounted
    getGroups();

  }, []);

  return (
    <>
      <div className={styles.boxForward}>
        <div className={styles.boxSearch}>
          <div className={styles.searchItem}>
            <Search 
              size="large"
              enterButton
              className={styles.__Search}
              placeholder={t("Search")}
              onChange={(event: any) => {
                let v: any = event.target.value;
                let filndFriends: any = JSON.parse(JSON.stringify(friendsDetail));
                let filndGroups: any = JSON.parse(JSON.stringify(groupsDetail));
                if (v !== "") {
                  filndFriends = friendsDetail.filter((item: any) => {
                    return item?.friend?.username?.toLowerCase().indexOf(v.toLowerCase()) !== -1;
                  });
                  filndGroups = groupsDetail.filter((item: any) => {
                    if (
                      item?.id !== currentGroupId &&
                      item?.privacyLevel !== 4
                    ) {
                      return item?.name?.toLowerCase().indexOf(v.toLowerCase()) !== -1;
                    }
                  });
                  setFriendsResult(filndFriends);
                  setGroupsResult(filndGroups);
                } else {
                  setFriendsResult(friendsDetail);
                  setGroupsResult(groupsDetail);
                }
              }}
            />
          </div>
        </div>
        {isLoading && <UIForwardSkeleton />}
        {!isLoading && (
          <div className={styles.boxResultSearch}>
            <div className={styles.boxResultGroup}>
              <div className={styles.titleGroup}>
                <p style={{ fontWeight: "bold" }}>{t("Groups")}</p>
              </div>
              <div className={styles.itemGroup}>
                {groupsResult?.map?.((item: any) => {
                  if (
                    item?.id !== currentGroupId  &&
                    item?.privacyLevel !== 4
                  ) {
                    return (
                      <div
                        key={item?.id}
                        className={styles.groupItem}
                        onClick={() => handleClickSelect(item?.id)}
                      >
                        <input
                          type="checkbox"
                          id={"check_" + item?.id}
                          name="selectGroup"
                          value={item?.id}
                          onClick={() => handleClickSelect(item?.id)}
                        />
                        <div className={styles.profileItem}>
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              backgroundColor: "#b8b8b8",
                              backgroundPosition: "0",
                              backgroundImage: `url(${getUrlHttp(item?.coverImgURL)})`,
                              backgroundSize: "cover",
                            }}
                          ></div>
                        </div>
                        <div className={styles.itemName}>
                          <p className={styles.textName}>{item?.name + " "}</p> 
                          <p style={{margin:"auto"}}> ({item?.totalMember})</p>
                        </div>
                      </div>
                    );
                  }
                })}
                {groupsResult?.length === 1 && groupsResult[0]?.id === currentGroupId && (
                  <div className={styles.bocNoResult}>
                    {t("No results found")}
                  </div>
                )}
                {groupsResult?.length === 0 && (
                  <div className={styles.bocNoResult}>
                    {t("No results found")}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.boxResultFriends}>
              <div className={styles.titleFriends}>
                <p style={{ fontWeight: "bold" }}>{t("Friends")}</p>
              </div>
              <div className={styles.itemFriends}>
                {friendsResult?.map?.((item: any) => {
                  if ( item?.friendID !== userId )
                  return (
                    <div
                      key={item.friend.id}
                      className={styles.groupItem}
                      onClick={() => handleClickSelect(item?.friendID)}
                    >
                      <input
                        type="checkbox"
                        id={"check_" + item?.friendID}
                        name="selectfriend"
                        value={item?.friendID}
                        onClick={() => handleClickSelect(item?.friendID)}
                      />
                      <div className={styles.profileItem}>
                        <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              backgroundColor: "#b8b8b8",
                              backgroundPosition: "0",
                              backgroundImage: `url(${getUrlHttp(item?.friend?.imageProfileURL)})`,
                              backgroundSize: "cover",
                            }}
                          ></div>
                      </div>
                      <div className={styles.itemName}>
                        <p className={styles.textName}>{getFullName(item?.friend)}</p>
                      </div>
                    </div>
                  );
                })}
                {friendsResult?.length < 1 && (
                  <div className={styles.bocNoResult}>
                    {t("No results found")}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        <div className={styles.boxShare}>
          <div className={styles.bottomBtn}>
            <Button
              shape="round"
              block
              disabled={isLoading || isLoadingData || countSelect === 0}
              loading={isLoadingData}
              onClick={() => forwerdMessageToAnotherChat()}
              style={{ backgroundColor: " #0F4C82", color:"#fff" }}
            >
              {t("Share")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
});
UIForwardMessages.displayName = "UIForwardMessages";
export default UIForwardMessages;
